import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-none border px-2 py-0.5 text-[11px] font-mono uppercase tracking-[0.12em] transition-colors focus:outline-none focus:ring-1 focus:ring-ink",
  {
    variants: {
      variant: {
        default:
          "border-ink bg-ink text-white",
        secondary:
          "border-rule bg-surface-alt text-ink",
        destructive:
          "border-alert bg-alert/10 text-alert",
        outline: "border-rule text-ink bg-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
